import { StatusTag } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { LoanStatuses } from '@app/configs/loanApplication';
const getVariant = (status) => {
    switch (status.toLowerCase()) {
        case LoanStatuses.Paid:
        case LoanStatuses.Active:
        case LoanStatuses.Collecting:
        case LoanStatuses.Collected:
            return 'success';
        case LoanStatuses.Canceled:
        case LoanStatuses.Cancelled:
            return 'disabled';
        default:
            return 'critical';
    }
};
const LoanStatus = ({ status }) => {
    const { t } = useTranslation();
    return (<StatusTag variant={getVariant(status)} label={t(`financing.loan_status.${status.toLowerCase()}`)} isFilledIcon={false}/>);
};
export default LoanStatus;
